import { render, staticRenderFns } from "./ManagementIndicatorsIndex.vue?vue&type=template&id=7639bc94"
import script from "./ManagementIndicatorsIndex.vue?vue&type=script&lang=js"
export * from "./ManagementIndicatorsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports